
export default {
  isLogin: state => !!state.vuex_token,
  // token: state => 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3Mjc0MzEwNTQsInVzZXJuYW1lIjoiMTgxMDIzOTIwMDA5NjY4NjA4MiJ9.OkAnhAKnmq3BaatlqUzI7pKBN9ZDQBwKWHtLH5-XEi0',
  token: state => state.vuex_token,
  userInfo: state => state.vuex_user || {},
  roleCode: state => state.vuex_user.roleCode,
  isDirector: state => state.vuex_user.isDirector,
  userId: state => state.vuex_user.id,

  //
  area:state=>state.app.area,
  userType: state => state.vuex_user ? state.vuex_user.userType : 1,
  permissions: state => state.vuex_authorities,
}
